export class MenuState {
  isMenuOpen: boolean;
  isProfileOpen: boolean;
  isASubMenuOpen?: boolean;

  constructor(
    isMenuOpen?: boolean,
    isProfileOpen?: boolean,
    isSubMenuOpen?: boolean
  ) {
    this.isMenuOpen = isMenuOpen ?? false;
    this.isProfileOpen = isProfileOpen ?? false;
    this.isASubMenuOpen = isSubMenuOpen ?? false;
  }
}
